module.exports = __webpack_public_path__ + "static/media/join-radio.815a3a31.png";